import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucXaPhuong } from 'src/app/shared/DanhMucXaPhuong.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class DanhMucXaPhuongService extends BaseService{

    list: DanhMucXaPhuong[] | undefined;
    list001: DanhMucXaPhuong[] | undefined;
    formData!: DanhMucXaPhuong;

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "DanhMucXaPhuong";
    }

    GetSQLByThanhVienIDAndActiveAndParentIDToListAsync() {
        var lastUpdatedMembershipID = localStorage.getItem(environment.ThanhVienID);
        if (lastUpdatedMembershipID) {
            this.baseParameter.ThanhVienID = Number(lastUpdatedMembershipID);
        }
        this.baseParameter.Active = true;
        let url = this.aPIURL + this.controller + '/GetSQLByThanhVienIDAndActiveAndParentIDToListAsync';
        const formUpload: FormData = new FormData();
        formUpload.append('data', JSON.stringify(this.baseParameter));
        return this.httpClient.post(url, formUpload);
    }
}

